export default "__VITE_ASSET__Dyx7dh2C__"